/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const OverflowHorizontalIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M9.625 16C9.625 16.9665 8.8415 17.75 7.875 17.75C6.9085 17.75 6.125 16.9665 6.125 16C6.125 15.0335 6.9085 14.25 7.875 14.25C8.8415 14.25 9.625 15.0335 9.625 16Z" />
      <path d="M15.75 16C15.75 16.9665 14.9665 17.75 14 17.75C13.0335 17.75 12.25 16.9665 12.25 16C12.25 15.0335 13.0335 14.25 14 14.25C14.9665 14.25 15.75 15.0335 15.75 16Z" />
      <path d="M20.125 17.75C21.0915 17.75 21.875 16.9665 21.875 16C21.875 15.0335 21.0915 14.25 20.125 14.25C19.1585 14.25 18.375 15.0335 18.375 16C18.375 16.9665 19.1585 17.75 20.125 17.75Z" />
    </BaseIcon>
  );
};
